import React, { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Box, Text } from "@mantine/core";
import { userAuth } from "../utils/Authorization";
import { msalInstance } from "../utils/MsalInstance";

interface ProtectedRouteProps {
    children: ReactNode,
    requiredRoles?: string[];
    anyRole?: boolean;
}

function ProtectedRoute({ children, requiredRoles = [], anyRole }: ProtectedRouteProps) {
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        const onPageLoad = async () => {
            if (msalInstance.getActiveAccount() === null) {
                navigate("/login");
            }

            setIsAuthorized(userAuth.hasRequiredRoles(requiredRoles, anyRole));
        };

        onPageLoad();
    }, [navigate, requiredRoles]);

    if(isAuthorized === null)
        return null;

    if (isAuthorized) {
        return (
            <>
                {children}
            </>
        )
    }
    else {
        return (
            <Box style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <Text size="4rem" mb="sm">403</Text>
                <Text size="1.5rem" mb="lg">Access Denied</Text>
                <Text size="1.125rem" mb="lg">Sorry, but you don't have permission to access this page.</Text>
                <Text c="var(--text-dimmed)">Please contact your IT administrator if this is an error.</Text>
            </Box>
        )
    }
}

export {
    ProtectedRoute
}